import positionImages from './positionImages';
import PositionNumber from './PositionNumber';
import Img from '@/shared/components/Img';

type Props = {
  position?: number;
  showMedalIcons?: boolean;
  isMyScore?: boolean;
  size?: 'Default' | 'Small';
  isBitcasino: boolean;
};

const Position: React.FC<Props> = ({
  size,
  isMyScore,
  showMedalIcons,
  position,
  isBitcasino,
}) => {
  const positionImage = positionImages[position ?? 1];
  return (
    <div className="flex items-center justify-start text-center">
      {showMedalIcons && positionImage ? (
        <Img src={positionImage} alt={''} />
      ) : (
        <PositionNumber
          size={size}
          isMyScore={isMyScore}
          isBitcasino={isBitcasino}
        >
          {position}
        </PositionNumber>
      )}
    </div>
  );
};

export default Position;
